module.exports = __webpack_public_path__ + "static/media/eh-pres.1c69e4c7.jpg";